require('raf').polyfill()



// WEBPACK FOOTER //
// ./lib/commons/polyfills.js